var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaretUpIconRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 22C17.575 22 22.5 17.075 22.5 11C22.5 4.925 17.575 -4.30557e-07 11.5 -9.61651e-07C5.425 -1.49274e-06 0.500001 4.925 0.500001 11C0.5 17.075 5.425 22 11.5 22ZM14.793 13.207C14.9816 13.3892 15.2342 13.49 15.4964 13.4877C15.7586 13.4854 16.0094 13.3802 16.1948 13.1948C16.3802 13.0094 16.4854 12.7586 16.4877 12.4964C16.49 12.2342 16.3892 11.9816 16.207 11.793L12.207 7.793C12.0195 7.60553 11.7652 7.50021 11.5 7.50021C11.2348 7.50021 10.9805 7.60553 10.793 7.793L6.793 11.793C6.61084 11.9816 6.51005 12.2342 6.51233 12.4964C6.5146 12.7586 6.61977 13.0094 6.80518 13.1948C6.99059 13.3802 7.2414 13.4854 7.5036 13.4877C7.7658 13.49 8.0184 13.3892 8.207 13.207L11.5 9.914L14.793 13.207Z",
    fill: "#CF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUpIconRed);
export default __webpack_public_path__ + "static/media/caret-up-icon-red.73d9b06495c2fd2113374ee840965947.svg";
export { ForwardRef as ReactComponent };